import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "../api/client";
import { useAuth } from "../context/AuthContext";
import { Icon } from "./ui";
import { VoucherChooser } from "./VoucherChooser";

const builderLinks = [
  { to: "/", label: "Today", hint: "Cash summary", icon: "home" },
  { to: "/sales", label: "Sales", hint: "Customers", icon: "sales" },
  { to: "/projects", label: "Projects", hint: "Housing schemes", icon: "projects" },
  { to: "/expenses", label: "Expenses", hint: "Money out", icon: "expense" },
  { to: "/vendors", label: "Vendors", hint: "Khata / udhar", icon: "users" },
  { to: "/vendors/udhar", label: "Credits", hint: "Vendors with udhar", icon: "cash" },
  { to: "/banks", label: "Banks", hint: "Cheque / online / pay order", icon: "bank" },
  { to: "/ledger", label: "Daily book", hint: "Day by day", icon: "ledger" },
  { to: "/logs", label: "Activity log", hint: "Before and after", icon: "logs" },
];

const adminLinks = [
  { to: "/", label: "Overview", hint: "Today's cash", icon: "home" },
  { to: "/builders", label: "Builders", hint: "Accounts", icon: "users" },
  { to: "/sales", label: "Sales", hint: "Customers", icon: "sales" },
  { to: "/projects", label: "Projects", hint: "Housing schemes", icon: "projects" },
  { to: "/expenses", label: "Expenses", hint: "Money out", icon: "expense" },
  { to: "/vendors", label: "Vendors", hint: "Khata / udhar", icon: "users" },
  { to: "/vendors/udhar", label: "Credits", hint: "Vendors with udhar", icon: "cash" },
  { to: "/banks", label: "Banks", hint: "Cheque / online / pay order", icon: "bank" },
  { to: "/ledger", label: "Daily book", hint: "Day by day", icon: "ledger" },
  { to: "/logs", label: "Activity log", hint: "Before and after", icon: "logs" },
];

export default function Layout() {
  const { user, isAdmin, isBuilder, logout, builderScope, setBuilderScope } = useAuth();
  const [open, setOpen] = useState(false);
  const [voucherOpen, setVoucherOpen] = useState(false);
  const [builders, setBuilders] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const links = isAdmin ? adminLinks : builderLinks;

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!isAdmin) return;
    api("/builders", { query: { limit: 100 } })
      .then((res) => {
        const items = res.data?.items || [];
        setBuilders(items);
        if (!builderScope && items[0]?.id) setBuilderScope(items[0].id);
      })
      .catch(() => setBuilders([]));
  }, [isAdmin, builderScope, setBuilderScope]);

  return (
    <div className="shell">
      <aside className={`sidebar ${open ? "open" : ""}`}>
        <div className="brand">
          <span className="brand-mark">B</span>
          <div>
            <strong>Builder Books</strong>
            {/* <small>Simple cashbook</small> */}
          </div>
        </div>

        <nav className="side-nav">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/" || link.to === "/vendors"}
              className="side-link"
            >
              <Icon name={link.icon} />
              <span>
                <b>{link.label}</b>
                <small>{link.hint}</small>
              </span>
            </NavLink>
          ))}
        </nav>

        <button
          className="side-logout"
          onClick={() => {
            logout();
            navigate("/login");
          }}
        >
          <Icon name="logout" />
          Log out
        </button>
      </aside>

      {open ? <button className="nav-scrim" onClick={() => setOpen(false)} aria-label="Close menu" /> : null}

      <div className="main">
        <header className="topbar">
          <button className="icon-btn menu-btn" onClick={() => setOpen(true)} aria-label="Open menu">
            <Icon name="menu" />
          </button>
          <div className="who">
            <span className="who-name">{user?.name}</span>
            <span className="who-role">{isAdmin ? "Admin" : user?.identity || "Builder"}</span>
          </div>
          {isAdmin ? (
            <label className="scope">
              <span>Choose builder</span>
              <select value={builderScope} onChange={(event) => setBuilderScope(event.target.value)}>
                {builders.length === 0 ? <option value="">No builders yet</option> : null}
                {builders.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </label>
          ) : null}
        </header>
        <div className="page">
          <Outlet />
        </div>
      </div>

      <nav className="dock" aria-label="Quick pages">
        <NavLink to="/" end className="dock-item">
          <Icon name="home" size={20} />
          Today
        </NavLink>
        <NavLink to="/sales" className="dock-item">
          <Icon name="sales" size={20} />
          Sales
        </NavLink>
        {isBuilder ? (
          <button type="button" className="dock-add" onClick={() => setVoucherOpen(true)} aria-label="Add voucher">
            <Icon name="plus" size={22} />
          </button>
        ) : (
          <button type="button" className="dock-item" onClick={() => setOpen(true)}>
            <Icon name="menu" size={20} />
            More
          </button>
        )}
        <NavLink to="/expenses" className="dock-item">
          <Icon name="expense" size={20} />
          Expenses
        </NavLink>
        <NavLink to="/vendors/udhar" className="dock-item">
          <Icon name="cash" size={20} />
          Credits
        </NavLink>
      </nav>

      <VoucherChooser open={voucherOpen} onClose={() => setVoucherOpen(false)} />
    </div>
  );
}
